//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/NXObject.js";
import "../no/FacetSelectionRule.js";
let d=[[],[[["rules"],"AddRules",{},1,0],[["rules"],"RemoveRules",{},1,0],[[],"Destroy",{},0,0],[[],"RemoveAllFacets",{},0,0],[["numfacets"],"GetFacets",{R_:{facets:"IFacet[]"}},0,0]],[]];
SPLM.FacetCollector = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.FacetCollector";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;